import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfirmSignUp } from '@app/store';
import {
  ActionCompletion,
  Actions,
  ofActionCompleted,
  ofActionErrored,
  Store,
} from '@ngxs/store';
import { tap } from 'rxjs';

@Component({
  selector: 'app-confirm-sign-up',
  templateUrl: './confirm-sign-up.page.html',
  styleUrls: ['./confirm-sign-up.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class ConfirmSignUpPage implements OnInit {
  protected errorMessage?: string;
  protected confirmationSuccessful?: boolean;

  constructor(
    private store: Store,
    private actions$: Actions,
    private destroyRef: DestroyRef,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.processConfirmation();
  }

  private processConfirmation(): void {
    const token = this.activatedRoute.snapshot.paramMap.get('token');
    if (!token) {
      this.errorMessage = 'Confirmation token is missing.';
      return;
    }

    this.handleBackendResponse();
    this.store.dispatch(new ConfirmSignUp(token));
  }

  private handleBackendResponse(): void {
    this.actions$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        ofActionCompleted(ConfirmSignUp),
        tap(({ result }: ActionCompletion) => {
          this.confirmationSuccessful = result.successful;
          if (!this.confirmationSuccessful) {
            this.errorMessage = 'Invalid or expired confirmation token.';
          }
          this.cdRef.detectChanges();
        }),
      )
      .subscribe();

    this.actions$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        ofActionErrored(ConfirmSignUp),
        tap(() => {
          this.confirmationSuccessful = false;
          this.errorMessage =
            'A system error occurred. Unable to confirm sign-up.';
          this.cdRef.detectChanges();
        }),
      )
      .subscribe();
  }
}
